// 3p
import { combineReducers } from 'redux';

// Fp
import adapters from './adapters';
import authentication from './authentication';
import channels from './channels';
import draft from './draft';
import pages from './pages';
import profile from './profile';

export default combineReducers({
  adapters,
  authentication,
  channels,
  draft,
  pages,
  profile
});


/** WEBPACK FOOTER **
 ** ./src/store/reducers/index.js
 **/